import { mivoDb } from "@/domains/offline/db/mivoDb";
import type { IUser } from "@/domains/shared/models/IUser";

const AUTH_KEY = "me";

export async function cacheAuthUser(user: IUser): Promise<void> {
  await mivoDb.authProfile.put({ id: AUTH_KEY, user, updatedAt: Date.now() });
}

export async function getCachedAuthUser(): Promise<IUser | null> {
  const row = await mivoDb.authProfile.get(AUTH_KEY);
  return (row?.user as IUser) ?? null;
}
